import CmsService from '../cms.service'
import { NewsType } from '../../type/NewsType'
import { QueryParams } from '../../type/QueryParams'

class NewsService extends CmsService {
    public get(params: QueryParams) {
        return new Promise<Array<NewsType>>((resolve, reject) => {
            this.client
                .get('news-articles', {
                    params,
                })
                .then((response) => {
                    const news = response.data.map((item: NewsType) => {
                        return {
                            ...item,
                            url: `/news/${item.id}`,
                        }
                    })
                    resolve(news)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    public getById(id: string, params: QueryParams = {}) {
        return new Promise<NewsType>((resolve, reject) => {
            this.client
                .get(`news-articles/${id}`, {
                    params,
                })
                .then((response) => {
                    resolve(response.data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    public getCount() {
        return new Promise<number>((resolve, reject) => {
            this.client
                .get('news-articles/count')
                .then((response) => {
                    resolve(response.data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    public getNewsBanner() {
        return new Promise<any>((resolve, reject) => {
            this.client
                .get('news-banners?_sort=id:DESC')
                .then((response) => {
                    resolve(response.data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }
}

export default new NewsService()
